const mediaItems = [
  {
    title: '庆余年3 先导预告',
    desc: '权谋江湖再起，范闲归来',
    type: '预告片',
    duration: '02:35',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20trailer%20style%20visual%2C%20epic%20palace%20scenes%20with%20golden%20lighting%2C%20martial%20arts%20action%20pose%2C%20cinematic%20wide%20shot%2C%20dramatic%20composition%2C%20film%20grain%20texture%2C%20historical%20costume%20drama%20mood&width=600&height=340&seq=media-qyn-01&orientation=landscape',
  },
  {
    title: '狂飙 精彩片段回顾',
    desc: '高启强安欣巅峰对戏',
    type: '片段',
    duration: '05:18',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20crime%20drama%20intense%20scene%2C%20two%20men%20confrontation%20in%20interrogation%20room%2C%20dramatic%20lighting%20with%20shadows%2C%20suspenseful%20atmosphere%2C%20cinematic%20composition%2C%20police%20drama%20visual&width=600&height=340&seq=media-kb-02&orientation=landscape',
  },
  {
    title: '眼泪女王 幕后花絮',
    desc: '金秀贤金智媛片场甜蜜互动',
    type: '花絮',
    duration: '03:42',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20behind%20the%20scenes%20visual%2C%20actor%20and%20actress%20laughing%20on%20set%2C%20warm%20lighting%2C%20casual%20production%20atmosphere%2C%20film%20crew%20and%20cameras%2C%20soft%20romantic%20mood%2C%20elegant%20interior%20setting&width=600&height=340&seq=media-ylnw-03&orientation=landscape',
  },
  {
    title: '三体 特效制作揭秘',
    desc: '国产科幻视觉革命幕后',
    type: '特辑',
    duration: '08:10',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20visual%20effects%20production%20scene%2C%20futuristic%20technology%20and%20computer%20screens%2C%20cosmic%20phenomenon%20rendering%2C%20dark%20space%20theme%20with%20light%20effects%2C%20professional%20VFX%20studio%20atmosphere%2C%20cinematic%20sci-fi%20aesthetic&width=600&height=340&seq=media-st-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
          精彩预告
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/80 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-1 truncate">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}